<template lang="pug">
.mg-game__deck
  span.mg-game__deck__label {{ $t('game.deck') }}
  button.mg-game__deck__button(@click="drawCard('one')")
    span
  span.mg-game__deck__count {{ getDeckCount }}
  button.button.button-medium(v-if="showButton" @click="drawCard('all')") {{ $t("game.open_all") }}
</template>

<script>
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapGetters } = createNamespacedHelpers(mg_global);

export default {
  name: "GameDeck",

  computed: {
    ...mapGetters(["getDeckCount", "isDeckBlocked", "getActivityType"]),
    showButton() {
      return this.getDeckCount >= 2;
    }
  },

  methods: {
    drawCard(type) {
      if (this.getDeckCount <= 0) {
        this.$notify({
          type: "error",
          closeOnClick: "true",
          duration: 5000,
          group: "collection",
          position: "bottom right",
          text: this.$t(`error.no_cards.${this.getActivityType}`),
        });
      } else {
        this.$emit("startProgress");
        type === "all"
          ? this.$store.commit(`${mg_global}/setPopup`, "new_card_all")
          : this.$store.commit(`${mg_global}/setPopup`, "new_card");
      }
    },
  },
};
</script>
